import { yup } from '../../../shared/utils/yup';
import { IPortalCourse } from '../../course/types';

const yupCourse: Partial<Record<keyof IPortalCourse, yup.BaseSchema>> = {};

export const courseShema = yup.object({}).shape(yupCourse);
